import { giphyLightGrey } from '@giphy/js-brand'
import { IUser } from '@giphy/js-types'
import { Title as BrandTitle } from '@giphy/react-giphy-brand'
import React, { useContext, useState } from 'react'
import UserContext from 'shared/components/context/user'
import SearchOptionsContext from 'shared/components/context/search-options'
import { bodyFont } from 'shared/css/fonts'
import { desktop, mobile } from 'shared/util/media-query'
import styled from 'styled-components'
import ReportSearchModal from '../report-search'

// copied from mainTitleMobile in typography.css
// tyring to use brand...
// feel like this should maybe shared across mobile?
const Title = styled(BrandTitle)`
    ${mobile.css`
        font-family: ${bodyFont};
        font-weight: bold;
    `}
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${desktop.css`
        font-size: 36px;
    `}
`

const Container = styled.div`
    width: 50%;
    text-align: left;
    align-self: center;
    flex-grow: 1;
    hyphens: auto;
    overflow: hidden;
    ${mobile.css`
        margin-top: 14px;
    `}
`

const NumberDisplay = styled.span`
    color: ${giphyLightGrey};
    padding-left: 0.4em;
    text-transform: none;
    font-size: 14px;
    white-space: pre;
    font-family: interface;
    font-weight: 700;
    &:before {
        content: attr(data-gif-count);
    }
`

const ReportSearchButton = styled.div`
    height: 20px;
    width: 20px;
    background-color: #2e2e2e;
    font-size: 10px;
    line-height: 22px;
    vertical-align: middle;
    text-align: center;
    display: inline-block;
    margin: 0 6px 0 12px;
    cursor: pointer;

    &:hover {
        background-color: #5c5c5c;
    }
`

type Props = {
    displayTerm?: string
    totalCount?: number
    user: IUser
}
export const SearchResultsDisplay = ({ displayTerm, totalCount, user: { username } }: Props) => {
    const { user: loggedInUser } = useContext(UserContext)
    const { type, searchResponseId, clipSearchResponseId } = useContext(SearchOptionsContext)
    const [reportModal, setReportModal] = useState(false)
    const getTitle = (displayTerm?: string, username?: string) => {
        if (displayTerm) {
            return displayTerm
        } else if (username) {
            return `All the ${username} GIFs`
        } else {
            return ''
        }
    }
    return (
        <Container>
            <Title as="h1">
                {getTitle(displayTerm, username)}
                {loggedInUser.isStaff && (
                    <ReportSearchButton className={'ss-flag'} onClick={() => setReportModal(true)}></ReportSearchButton>
                )}
                {typeof totalCount === 'number' && (
                    <NumberDisplay data-gif-count={totalCount.toLocaleString()}>
                        {` ${type === 'stickers' ? 'Sticker' : 'GIF'}${totalCount === 1 ? '' : 's'}`}
                    </NumberDisplay>
                )}
            </Title>

            {reportModal && (
                <ReportSearchModal
                    type={type === 'stickers' ? 'stickers' : 'gifs'}
                    searchResponseId={searchResponseId}
                    clipSearchResponseId={clipSearchResponseId}
                    searchTerm={displayTerm ?? ''}
                    onClose={() => setReportModal(false)}
                />
            )}
        </Container>
    )
}
export default SearchResultsDisplay
